<header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom rounded-top-1">
  <i class="me-2 fas fa-ban" aria-hidden="true"></i>
  <h6 class="m-0">Блокирани потребители</h6>
</header>
@if (!loading) {
  @if (!!userBlocks && userBlocks.length !== 0) {
    <ul class="m-0 list-unstyled">
      @for (user of userBlocks; track user.userBlockId) {
        <li class="p-3 d-flex justify-content-between align-items-center border-bottom">
            <span class="fw-medium">
              <a class="text-primary-emphasis text-decoration-none"
                 [routerLink]="[appRoutes.root, appRoutes.profile, user.blockedUserId]">
                {{ user.blockedUsername }}
              </a>
          <p class="small text-muted m-0">
            {{ user.dateTime | date: 'dd:MM:yyyy г., HH:mm ч.' }}
          </p>
        </span>
          <button class="btn btn-sm btn-nz-primary flex-shrink-0"
                  [disabled]="loadingDeleteUserBlock"
                  (click)="deleteUserBlock(user)">
            @if (user.userBlockId == selectedUserBlockId) {
              <span class="spinner-border spinner-border-sm"></span>
            } @else {
              <i class="fas fa-user-check" aria-hidden="true"></i>
            }
            <span class="ms-2">Деблокирай</span>
          </button>
        </li>
      }
    </ul>
  } @else {
    <div class="p-3 text-muted">
      Няма намерени потребители
    </div>
  }
} @else {
  <section class="my-5">
    <div class="text-center">
      <h2>
        <i class="text-dark fa-solid fa-spinner fa-spin"></i>
      </h2>
      <h5 class="text-muted">Зареждане...</h5>
    </div>
  </section>
}
